const STATUS_COLORS = {
  free:      { bg: "#16a34a", border: "#15803d", text: "white" },
  morning:   { bg: "#fde68a", border: "#d97706", text: "#78350f" },
  afternoon: { bg: "#f97316", border: "#c2410c", text: "white" },
  evening:   { bg: "#92400e", border: "#78350f", text: "white" },
};

// Prioritet – večer > poslijepodne > jutro
const STATUS_PRIORITY = ["evening", "afternoon", "morning", "free"];

const DOT_COLORS = {
  morning:   "#fde68a",
  afternoon: "#f97316",
  evening:   "#92400e",
};

const TableCard = ({ table, imgScale = 1, onClick }) => {
  const rawWidth = Number(table.width || 50);
  const rawHeight = Number(table.height || 40);
  const finalWidth = Math.max(12, Math.round(rawWidth * imgScale));
  const finalHeight = Math.max(12, Math.round(rawHeight * imgScale));
  const isRound = table.type === "round" || table.type === "bar_stool";
  const scaledFontSize = Math.max(8, Math.round(14 * imgScale));

  const statuses = Array.isArray(table.status) ? table.status : [table.status || "free"];
  const isFree = statuses.includes("free") || statuses.length === 0;

  // Odaberi dominantnu boju po prioritetu
  const dominantStatus = STATUS_PRIORITY.find(s => statuses.includes(s)) || "free";
  const color = STATUS_COLORS[dominantStatus];

  // Točkice za ostale statuse (ne dominantni)
  const dotStatuses = statuses.filter(s => s !== dominantStatus && s !== "free");
  const dotSize = Math.max(4, Math.round(6 * imgScale));

  const cardStyle = {
    width: `${finalWidth}px`,
    height: `${finalHeight}px`,
    borderRadius: isRound ? "50%" : "6px",
    boxSizing: "border-box",
    borderWidth: `${Math.max(1, 2 * imgScale)}px`,
    borderStyle: "solid",
    borderColor: color.border,
    background: color.bg,
    fontSize: `${scaledFontSize}px`,
    lineHeight: 1,
    color: color.text,
    position: "relative",
    boxShadow: `
      0px ${1 * imgScale}px ${2 * imgScale}px rgba(0,0,0,0.12),
      0px ${2 * imgScale}px ${4 * imgScale}px rgba(0,0,0,0.10)
    `,
    transition: "box-shadow 0.2s ease, transform 0.15s ease",
  };

  return (
    <div
      onClick={() => onClick && onClick(table)}
      className={`
        flex items-center justify-center cursor-pointer font-bold
        hover:scale-105
        ${!isFree ? "animate-pulse" : ""}
      `}
      style={cardStyle}
    >
      {table.label}

      {/* Točkice u gornjem desnom uglu za dodatne termine */}
      {dotStatuses.length > 0 && (
        <div style={{
          position: "absolute",
          top: 2,
          right: 2,
          display: "flex",
          gap: "2px",
        }}>
          {dotStatuses.map(s => (
            <div key={s} style={{
              width: dotSize,
              height: dotSize,
              borderRadius: "50%",
              backgroundColor: DOT_COLORS[s],
              border: "1px solid rgba(0,0,0,0.3)",
            }} />
          ))}
        </div>
      )}
    </div>
  );
};

export default TableCard;